import React from 'react';
import { string } from 'prop-types';
import { Alert } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/i18n-react';

import classes from './style.module.scss';

const WarningMessage = ({ messageKey }) => {
    const title = (
        <span className="tbody-6">
            <I18n k={`send_message.validation.${messageKey}.title`}/>
        </span>
    );

    const text = (
        <span className="tbody-6">
            <I18n k={`send_message.validation.${messageKey}.message`}/>
        </span>
    );

    return (
        <Alert className={classes.warningMessage}
            title={title}
            text={text}
            theme={Alert.THEMES.WARNING}/>
    );
};

WarningMessage.propTypes = {
    messageKey: string
};

export default WarningMessage;
